import repository from "@/services/repository";

const resource = "/invoices";

export default {
  paymentLookUp(
    options: any,
    invoiceId?: string,
    projectId?: string,
  ) {
    const formData = new FormData();

    for (const key in options) {
      if (options.hasOwnProperty(key)) {
        formData.append(key, JSON.stringify(options[key]));
      }
    }

    if (invoiceId) {
      return repository.post(
        `${resource}/PaymentLookUp?invoiceId=${invoiceId}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
    }

    if (projectId) {
      return repository.post(
        `${resource}/PaymentLookUp?projectId=${projectId}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
    }

    return repository.post(`${resource}/PaymentLookUp`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
};
